export default function ({ store, redirect, error, route }) {
    // eslint-disable-next-line eqeqeq
    if (store.getters.year && route.query.year != store.getters.year) {
        return redirect({
            path: route.path,
            query: { ...route.query, year: store.getters.year }
        })
    }
}
